var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.withApplicantName
        ? _c("h2", [_vm._v(_vm._s(_vm.applicantName))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          staticClass: "mt-3",
          attrs: {
            label: "Wähle bitte aus:",
            state: _vm.exclusionTypeValid,
            "label-classes": ["font-weight-bold"]
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "b-form-radio",
                {
                  attrs: {
                    value: _vm.exclusionTypes.job,
                    name: "customer-send-off"
                  },
                  on: {
                    change: function($event) {
                      return _vm.exclusionTypeChanged(_vm.exclusionTypes.job)
                    }
                  },
                  model: {
                    value: _vm.exclusionType,
                    callback: function($$v) {
                      _vm.exclusionType = $$v
                    },
                    expression: "exclusionType"
                  }
                },
                [
                  _c("div", { staticClass: "font-weight-extra-bold" }, [
                    _vm._v("\n\t\t\t\t\tFür diesen Job von "),
                    _c("span", { staticClass: "color-primary" }, [
                      _vm._v(_vm._s(_vm.applicantName))
                    ]),
                    _vm._v(
                      " verabschieden,\n\t\t\t\t\tandere Jobs sind möglich\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n\t\t\t\t\tNur für diesen Job von dieser Person verabschieden, aber für eine anderen Job könnte eine\n\t\t\t\t\tZusammenarbeit mit dieser Person möglich sein.\n\t\t\t\t"
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex mt-3" },
            [
              _c(
                "b-form-radio",
                {
                  attrs: {
                    value: _vm.exclusionTypes.jobTemporary,
                    name: "customer-send-off"
                  },
                  on: {
                    change: function($event) {
                      return _vm.exclusionTypeChanged(
                        _vm.exclusionTypes.jobTemporary
                      )
                    }
                  },
                  model: {
                    value: _vm.exclusionType,
                    callback: function($$v) {
                      _vm.exclusionType = $$v
                    },
                    expression: "exclusionType"
                  }
                },
                [
                  _c("div", { staticClass: "font-weight-extra-bold" }, [
                    _vm._v("\n\t\t\t\t\tNur vorläufig für diesen Job von "),
                    _c("span", { staticClass: "color-primary" }, [
                      _vm._v(_vm._s(_vm.applicantName))
                    ]),
                    _vm._v(
                      "\n\t\t\t\t\tverabschieden, später wieder möglich\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n\t\t\t\t\tAktuell für diesen Job verabschieden, aber eventuell ist später für diesen oder einen sehr\n\t\t\t\t\tähnlichen Job eine Zusammenarbeit mit dieser Person denkbar und interessant.\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.exclusionTypeValidUntilMonthsEligible
                    ? _c(
                        "FormGroup",
                        {
                          staticClass: "my-2",
                          attrs: {
                            label:
                              "In wie vielen Monaten ist eine Zusammenarbeit wieder denkbar? Die Person wird dir nach den ausgewählten Monaten wieder angezeigt, sollte sie dann verfügbar und interessiert sein.",
                            state: _vm.exclusionTypeValidUntilMonthsValid
                          }
                        },
                        [
                          _c("Select", {
                            attrs: { options: _vm.validUntilOptions },
                            on: { change: _vm.emitChangeEvent },
                            model: {
                              value: _vm.exclusionTypeValidUntilMonths,
                              callback: function($$v) {
                                _vm.exclusionTypeValidUntilMonths = $$v
                              },
                              expression: "exclusionTypeValidUntilMonths"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex mt-3" },
            [
              _c(
                "b-form-radio",
                {
                  attrs: {
                    value: _vm.exclusionTypes.total,
                    name: "customer-send-off"
                  },
                  on: {
                    change: function($event) {
                      return _vm.exclusionTypeChanged(_vm.exclusionTypes.total)
                    }
                  },
                  model: {
                    value: _vm.exclusionType,
                    callback: function($$v) {
                      _vm.exclusionType = $$v
                    },
                    expression: "exclusionType"
                  }
                },
                [
                  _c("div", { staticClass: "font-weight-extra-bold" }, [
                    _vm._v("\n\t\t\t\t\tVollständig von "),
                    _c("span", { staticClass: "color-primary" }, [
                      _vm._v(_vm._s(_vm.applicantName))
                    ]),
                    _vm._v(" verabschieden\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n\t\t\t\t\tFür alle derzeitigen und zukünftigen Jobs von dieser Person verabschieden. Du kannst diese\n\t\t\t\t\tAuswahl später wieder ändern und danach die Person wieder kontaktieren, sollte diese dann\n\t\t\t\t\tverfügbar und interessiert sein.\n\t\t\t\t"
                    )
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isAnonymous
        ? _c("JonInfo", {
            staticClass: "mt-3",
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _c("p", [
                        _vm._v(
                          "Die Person erhält eine enstprechende Mitteilung und erfährt derzeit weder deinen Namen noch den Namen\n\t\t\t\teurer Organisation/Firma."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          'Verabschiedete Personen findest du unter "Verabschiedungen".'
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3346991001
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }